import { render } from "./CogsDataPage.vue?vue&type=template&id=dd3fc274&scoped=true"
import script from "./CogsDataPage.vue?vue&type=script&lang=js"
export * from "./CogsDataPage.vue?vue&type=script&lang=js"

import "./CogsDataPage.vue?vue&type=style&index=0&id=dd3fc274&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3fc274"]])

export default __exports__